// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   environment: 'development',
//   BASEURL: '',
//   // MOSQUITTO_HOST: 'localhost',
//   // MOSQUITTO_PORT: 4200,
//   MOSQUITTO_PATH: '/mqtt',
//   MOSQUITTO_CONNECTION_ON_CREATE: true
// };

export const environment = {
  production: false,
  MOSQUITTO_HOST: 'localhost',//'48.216.203.209',
  MOSQUITTO_PORT: 4200,
  MOSQUITTO_PATH: '/mqtt',
  MOSQUITTO_PROTOCOL: 'ws', // 'wss' si usas SSL
  MOSQUITTO_CONNECTION_ON_CREATE: true,
  BASEURL: '',
    openaiKey: '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'
};
